import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-584">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-585">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-586">
          <h3 className="text-2xl font-heading font-bold text-white mb-4 tracking-tight" data-id="element-587">
            SyNeural
          </h3>
          <p className="text-sm leading-relaxed" data-id="element-588">
            Building better judgment for a more capable society.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-589">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-590">
            Platform
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-591">
            <li data-id="element-592">
              <a href="#cji" className="hover:text-white transition-colors" data-id="element-593">
                CJI
              </a>
            </li>
            <li data-id="element-594">
              <a href="#ncji" className="hover:text-white transition-colors" data-id="element-595">
                NCJI
              </a>
            </li>
            <li data-id="element-596">
              <a href="#solutions" className="hover:text-white transition-colors" data-id="element-597">
                Solutions
              </a>
            </li>
            <li data-id="element-598">
              <a href="#home" className="hover:text-white transition-colors" data-id="element-599">
                Platform Overview
              </a>
            </li>
          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-600">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-601">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-602">
            <li data-id="element-603">
              <a href="#education" className="hover:text-white transition-colors" data-id="element-604">
                Education
              </a>
            </li>
            <li data-id="element-605">
              <a href="#employers" className="hover:text-white transition-colors" data-id="element-606">
                Employers
              </a>
            </li>
            <li data-id="element-607">
              <a href="#civil-society" className="hover:text-white transition-colors" data-id="element-608">
                Civil Society
              </a>
            </li>
            <li data-id="element-609">
              <a href="#government" className="hover:text-white transition-colors" data-id="element-610">
                Government
              </a>
            </li>
            <li data-id="element-611">
              <a href="#leadership" className="hover:text-white transition-colors" data-id="element-612">
                Leadership
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-613">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-614">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-615">
            <li data-id="element-616">
              <a href="#about" className="hover:text-white transition-colors" data-id="element-617">
                About
              </a>
            </li>
            <li data-id="element-618">
              <a href="#research" className="hover:text-white transition-colors" data-id="element-619">
                Research
              </a>
            </li>
            <li data-id="element-620">
              <a href="#partnerships" className="hover:text-white transition-colors" data-id="element-621">
                Partnerships
              </a>
            </li>
            <li data-id="element-622">
              <a href="#contact" className="hover:text-white transition-colors" data-id="element-623">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-624">
        <p data-id="element-625">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-626">
          <a href="#privacy" className="hover:text-white transition-colors" data-id="element-627">
            Privacy Policy
          </a>
          <a href="#terms" className="hover:text-white transition-colors" data-id="element-628">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}